/**
 * @pageName BookingsPolicyForm
 * @slotType dashboard plugin
 */
export type StaffAssignmentParams = { /* Policy ID.*/ policyId: string };
